<template>
    <div>

        <router-view
            @resetProfil="clearUserData"
            @updateProfil="getUserData"
            :profil.sync="profil"
            :spravy.sync="spravy"
            :kravicka.sync="kravicka"
            :obchod.sync="obchod"
            :satnik.sync="satnik"
            :album.sync="album"
        />

        <!-- Alert box -->
        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
            <span :class="'icon-'+responseType"></span>{{ responseText }}
        </div>        

    </div>
</template>



<script>
    //import bugsnagClient from './bugsnag'
    import EventService from '@/services/EventService.js'
    export default {
        data: () => ({
            profil:   {
                id: 0,
                pouzivatel_email: '',
                pouzivatel_id: {
                    album_pouzivatela: [],
                    farma_pouzivatela: [],
                    id: 0,
                    kravicky_pouzivatela: [],
                    level_id: 0,
                    pouzivatel_bankovky: 0,
                    pouzivatel_name: 'Meno',
                    pouzivatel_next_level_threshold: 0,
                    pouzivatel_wallet: 0,
                    pouzivatel_xp: 0,
                    spravy_pouzivatela: []
                }
            },



            //profil:   {},
            spravy:   0,
            kravicka: {},
            obchod:   {},
            satnik:   {},
            album:    {},

            responseType: '',
            responseText: ''
        }),
        mounted() {
        },
        methods: {
            clearUserData() {
                this.profil   = {}
                this.spravy   = 0
                this.kravicka = {}
                this.obchod   = {}
                this.satnik   = {}
                this.album    = {}

                EventService.saveTokenToSession('')
            },

            getUserData() {
                EventService.getUserData()
                    .then(response => {
                        console.log(response.data.data[0])
                        this.profil = response.data.data[0]
                    })
                    .catch(error => {
                        //console.log('There was an error:', error.response.data.error)
                        this.responseType = 'danger'
                        this.responseText = error.response.data.error
                    })

                
                EventService.getUnreadedMessages()
                    .then(response => {
                        this.spravy = response.data.data.length
                    })
                    .catch(error => {
                        //console.log('There was an error:', error.response.data.error)
                        this.responseType = 'danger'
                        this.responseText = error.response.data.error
                    })
            },

        }
    }
</script>